<template>
  <div class="content">
    <div class="loading" v-if="loading"></div>
    <template v-else>
      <perfect-scrollbar class="dashboard">
        <div class="panelCnt panelCnt3" v-if="loadingSummary">
          <div class="panelFull panelL1 panel3">
            <div class="chartDisabled loading"></div>
          </div>
          <div class="panelFull panelL1 panel3">
            <div class="chartDisabled loading"></div>
          </div>
          <div class="panelFull panelL1 panel3">
            <div class="chartDisabled loading"></div>
          </div>
        </div>
        <template v-else>
          <div class="panelCnt panelCnt3">
            <div class="panelFull panelL1 panel3">
              <div class="panelHeader">Total Tamu Undangan</div>
              <div class="panelNumber"><h4>{{summary.totalGuest.toLocaleString('id')}}</h4><span>Orang</span></div>
            </div>
            <div class="panelFull panelL1 panel3">
              <div class="panelHeader">Tamu Akan Hadir</div>
              <div class="panelNumber"><h4>{{summary.totalConfirmed.toLocaleString('id')}}</h4><span>Orang</span></div>
            </div>
            <div class="panelFull panelL1 panel3">
              <div class="panelHeader">Tamu Sudah Absen</div>
              <div class="panelNumber"><h4>{{summary.totalAttendanceConfirmed.toLocaleString('id')}}</h4><span>Orang</span></div>
            </div>
          </div>
        </template>

        <div class="panelCnt panelCnt3" v-if="loadingOverview">
          <div class="panelFull panelL1 panel3">
            <div class="chartDisabled loading"></div>
          </div>
          <div class="panelFull panelL1 panel3">
            <div class="chartDisabled loading"></div>
          </div>
          <div class="panelFull panelL1 panel3">
            <div class="chartDisabled loading"></div>
          </div>
        </div>
        <template v-else>
          <div class="panelCnt panelCnt3" v-for="(item, i) in overviews" :key="`ct${i}`">
            <div class="panelFull panelL1 panel3">
              <div class="panelHeader">Status Undangan</div>
              <div class="chartDisabled" v-if="!item.data1">No data available</div>
              <div :id="`chart-city-a-${item.id}`" v-else></div>
            </div>
            <div class="panelFull panelL1 panel3">
              <div class="panelHeader">Konfirmasi Kehadiran</div>
              <div class="chartDisabled" v-if="!item.data2">No data available</div>
              <div :id="`chart-city-b-${item.id}`" v-else></div>
            </div>
            <div class="panelFull panelL1 panel3">
              <div class="panelHeader">Status Absensi</div>
              <div class="chartDisabled" v-if="!item.data3">No data available</div>
              <div :id="`chart-city-c-${item.id}`" v-else></div>
            </div>
          </div>
        </template>

        <div class="panelCnt panelChart">
          <div class="panelFull activity">
            <div class="panelHeader">
              Invitation Created
              <div class="panelRight">
                <div class="panelCal pcl" v-on:click="prevMonth"></div>
                <span class="monthName">{{months[month.getMonth()]}} {{month.getFullYear()}}</span>
                <div class="panelCal" v-on:click="nextMonth"></div>
              </div>
            </div>
            <div class="activityCnt loading" v-if="loadingThisMonth"></div>
            <div class="activityCnt" v-else-if="thisMonths.length > 0">
              <div class="activities">
                <div class="activityItem" v-for="(item, i) in thisMonths" :key="`act${i}`">
                  <div class="activityBar">
                    <div class="theBar"
                      :style="{height: `${item.percentage}%`}"></div>
                    <div class="info" v-if="item.total">
                      {{item.timestamp | moment('DD MMM YYYY')}}
                      <h4>{{item.total.toLocaleString('id')}}</h4>
                      activities
                    </div>
                    <div class="info" v-else>
                      {{item.timestamp | moment('DD MMM YYYY')}}
                      <h4>0</h4>activities</div>
                  </div>
                  <div class="activityLabel">
                    {{item.timestamp | moment('DD MMM')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panelCnt panelChart">
          <div class="panelFull activity">
            <div class="panelHeader">
              Confirmation Received
              <div class="panelRight">
                <div class="panelCal pcl" v-on:click="prevMonth"></div>
                <span class="monthName">{{months[month.getMonth()]}} {{month.getFullYear()}}</span>
                <div class="panelCal" v-on:click="nextMonth"></div>
              </div>
            </div>
            <div class="activityCnt loading" v-if="loadingConfirmed"></div>
            <div class="activityCnt" v-else-if="confirmed.length > 0">
              <div class="activities">
                <div class="activityItem" v-for="(item, i) in confirmed" :key="`act${i}`">
                  <div class="activityBar">
                    <div class="theBar"
                      :style="{height: `${item.percentage}%`}"></div>
                    <div class="info" v-if="item.total">
                      {{item.timestamp | moment('DD MMM YYYY')}}
                      <h4>{{item.total.toLocaleString('id')}}</h4>
                      activities
                    </div>
                    <div class="info" v-else>
                      {{item.timestamp | moment('DD MMM YYYY')}}
                      <h4>0</h4>activities</div>
                  </div>
                  <div class="activityLabel">
                    {{item.timestamp | moment('DD MMM')}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panelCnt panelChart">
          <div class="panelFull activity interactions">
            <div class="panelHeader">Activity in the last 60 minutes</div>
            <div class="moreCnt" v-if="1>2">
              <div class="moreBtn" v-on:click="$router.push('/event-realtime')">
                View in realtime
              </div>
            </div>
            <div class="activityCnt loading" v-if="loadingLast60Event"></div>
            <div class="activityCnt" v-else-if="last60Events.length > 0">
              <div class="activities">
                <div class="activityItem noLabel"
                  v-for="(item, i) in last60Events" :key="`act${i}`">
                  <div class="activityBar">
                    <div class="theBar"
                      :style="{height: `${item.percentage}%`}"></div>
                    <div class="info" v-if="item.eventCount">
                      <template v-if="i === 59">Now</template>
                      <template v-else>{{60 - i}} mins ago</template>
                      <h4>{{item.eventCount.toLocaleString('id')}}</h4>
                      activities
                    </div>
                    <div class="info" v-else>
                      <template v-if="i === 59">Now</template>
                      <template v-else>{{60 - i}} mins ago</template>
                      <h4>0</h4> activities</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="panelCnt panelChart noBorder">
          <div class="panelFull activity interactions">
            <div class="panelHeader phTl">Activity timeline</div>
            <div class="eventTimeline tlLoading" v-if="loadingEventTl">
              <div class="tlh"></div>
            </div>
            <div class="eventTimeline" v-else-if="eventTl.length > 0">
              <div class="tlh"></div>
              <div class="tlf" v-on:click="$router.push('/event-realtime')">View in realtime</div>
              <div class="tlItem" v-for="(item, i) in eventTl" :key="`etl${i}`">
                <div class="tlTime">
                  <span>{{item.dateCreated | moment('DD MMM YYYY HH:mm')}}</span></div>
                <div class="tlInfo">
                  Absen Masuk
                  <table cellpadding="0" cellspacing="0">
                    <tr v-if="item.guest"><td class="td1">Tamu Undangan</td><td class="td2">:
                      </td><td>{{item.guest.name}}<span v-if="item.guest.position
                      || item.guest.organization">, {{item.guest.position || ''}}
                      {{item.guest.organization || ''}}</span></td></tr>
                    <tr v-if="item.author"><td>Petugas Absensi</td><td class="td2">:
                      </td><td>{{item.author.name}}</td></tr>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="tableInfo" v-if="!loading">
          &copy; {{$config.copyright}}. Powered by <a href="https://cmsriver.com"
          target="_blank">CMSRiver</a>
        </div>
      </perfect-scrollbar>
    </template>
    <AnalyticDetail ref="analyticDetail"/>
    <AddTodo ref="addTodo"/>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import ApexCharts from 'apexcharts';
import AnalyticDetail from '@/components/AnalyticDetail.vue';
import AddTodo from '@/components/AddTodo.vue';

// const mapboxgl = require('mapbox-gl/dist/mapbox-gl.js');

export default {
  name: 'articles',
  components: { AnalyticDetail, AddTodo },
  data() {
    return {
      loading: false,
      /**
       * Right bar
       *
       */
      loadingGotd: true,
      cotd: null,
      loadingPopularCategories: true,
      popularCategories: [],

      /**
       * Activity this month data
       *
       */
      month: new Date(),
      loadingThisMonth: true,
      thisMonths: [],
      loadingConfirmed: true,
      confirmed: [],
      months: ['January', 'February', 'March', 'April', 'May', 'June', 'July',
        'August', 'September', 'October', 'November', 'December'],

      /**
       * Journaling this month data
       * jm = journaling month
       *
       */
      jm: new Date(),
      loadingJournaling: true,
      journaling: [],

      /**
       * Overview and summary
       *
       */
      loadingOverview: true,
      overviews: [],
      loadingSummary: true,
      summary: null,

      /**
       * Device, browser and os
       *
       */
      loadingDeivce: true,
      device: null,

      /**
       * Average stay on site
       *
       */
      loadingAvgStay: true,
      avgStay: null,

      /**
       * Popular pages
       *
       */
      loadingPopularPages: true,
      popularPages: null,

      /**
       * What user do in page
       *
       */
      loadingWhatUserDo: true,
      eventByPages: [],

      /**
       * Event in the last 60 minutes
       *
       */
      loadingLast60Event: true,
      last60Events: [],

      /**
       * Event timeline
       *
       */
      loadingEventTl: true,
      eventTl: [],

      eventId: null,
    };
  },
  computed: {
    ...mapState(['lang']),
  },
  methods: {
    ...mapActions(['chTitle', 'chCGB', 'chDirId']),

    prevMonth() {
      this.month.setMonth(this.month.getMonth() - 1);
      this.getMonthly();
      this.getConfirmed();
    },
    nextMonth() {
      this.month.setMonth(this.month.getMonth() + 1);
      this.getMonthly();
      this.getConfirmed();
    },

    /**
     * This month data
     *
     */
    getMonthly() {
      this.loadingThisMonth = true;
      const uri = `invitation/${this.eventId}/guest/monthly/${Math.floor(this.month.getTime() / 1000)}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loadingThisMonth = false;
        this.thisMonths = r.data.data;
      }).catch((err) => {
        this.loadingThisMonth = false;
        this.thisMonths = [];
        console.error(err.message); // eslint-disable-line
      });
    },

    /**
     * This month data
     *
     */
    getConfirmed() {
      this.loadingConfirmed = true;
      const uri = `invitation/${this.eventId}/confirmed/monthly/${Math.floor(this.month.getTime() / 1000)}`;
      this.$http.get(this.$config.uri(uri)).then((r) => {
        this.loadingConfirmed = false;
        this.confirmed = r.data.data;
      }).catch((err) => {
        this.loadingThisMonth = false;
        this.confirmed = [];
        console.error(err.message); // eslint-disable-line
      });
    },

    /**
     * Overview
     *
     */
    getEventOverview() {
      this.loadingOverview = true;
      this.$http.get(this.$config.uri(`invitation/${this.eventId}/events/status`)).then((r) => {
        this.loadingOverview = false;
        this.overviews = r.data.data;
        setTimeout(() => {
          // eslint-disable-next-line
          for (const item of this.overviews) {
            const chartItem1 = new ApexCharts(document.querySelector(`#chart-city-a-${item.id}`), {
              chart: {
                type: 'donut',
                height: 200,
                toolbar: {
                  show: false,
                },
              },
              legend: {
                position: 'bottom',
                show: false,
              },
              dataLabels: {
                // enabled: false,
              },
              colors: ['#cdde00', '#ec174c', '#00b8a9', '#bbbbbb'],
              grid: {
                show: false,
              },
              series: item.data1,
              labels: item.series1,
            });
            chartItem1.render();

            const chartItem2 = new ApexCharts(document.querySelector(`#chart-city-b-${item.id}`), {
              chart: {
                type: 'donut',
                height: 200,
                toolbar: {
                  show: false,
                },
              },
              legend: {
                position: 'bottom',
                show: false,
              },
              dataLabels: {
                // enabled: false,
              },
              colors: ['#cdde00', '#ec174c', '#00b8a9', '#bbbbbb'],
              grid: {
                show: false,
              },
              series: item.data2,
              labels: item.series2,
            });
            chartItem2.render();

            const chartItem3 = new ApexCharts(document.querySelector(`#chart-city-c-${item.id}`), {
              chart: {
                type: 'donut',
                height: 200,
                toolbar: {
                  show: false,
                },
              },
              legend: {
                position: 'bottom',
                show: false,
              },
              dataLabels: {
                // enabled: false,
              },
              colors: ['#cdde00', '#ec174c', '#00b8a9', '#bbbbbb'],
              grid: {
                show: false,
              },
              series: item.data3,
              labels: item.series3,
            });
            chartItem3.render();
          }
        });
      }).catch((err) => {
        this.loadingOverview = false;
        console.error(err.message); // eslint-disable-line
      });
    },

    /**
     * Summary
     *
     */
    getEventSummary() {
      this.loadingSummary = true;
      this.$http.get(this.$config.uri(`invitation/${this.eventId}/events/summary`)).then((r) => {
        this.loadingSummary = false;
        this.summary = r.data.data;
      }).catch((err) => {
        this.loadingSummary = false;
      });
    },

    /**
     * Event in the last 60 minutes
     *
     */
    getLast60Event() {
      this.loadingLast60Event = true;
      this.$http.get(this.$config.uri(`invitation/${this.eventId}/activity/last60`)).then((r) => {
        this.loadingLast60Event = false;
        this.last60Events = r.data.data;
      }).catch((err) => {
        this.loadingLast60Event = false;
      });
    },

    /**
     * Event timeline
     *
     */
    getEventTimeline() {
      this.$http.get(this.$config.uri(`invitation/${this.eventId}/activity/timeline`)).then((r) => {
        this.loadingEventTl = false;
        this.eventTl = r.data.data;
      }).catch((err) => {
        this.loadingEventTl = false;
      });
    },
  },
  beforeDestroy() {
    if (coTimer) clearTimeout(coTimer);
  },
  mounted() {
    this.chTitle('Event Overview');
    this.chCGB(true);
    this.chDirId(0);

    this.eventId = Number(this.$route.query.id);
    if (Number.isNaN(this.eventId)) return;
    this.$http.get(this.$config.uri(`invitation/${this.eventId}/detail`)).then((r) => {
      if (r.data.status !== 200) return;
      this.chTitle(`${r.data.data.name} / Event Overview`);
      this.getEventOverview();
      this.getEventSummary();
      this.getMonthly();
      this.getConfirmed();
      this.getLast60Event();
      this.getEventTimeline();
    });
  },
};
</script>


<style scoped lang="scss">
.loading{
  background-image: url(../assets/loading-2.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
  height: 100%;
  width: 100%;
  &.sourceLoading{
    height: 260px;
  }
}
.chartDisabled{
  width: 160px; height: 160px;
  background-color: #eee;
  border-radius: 50%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: #999;
  &.loading{
    background-color: #fff;
  }
}
.content{
  position: relative;
  display: block;
  #mapbox{
    height: 400px;
    position: absolute;
    left: 0; right: 0; top: 0;
    z-index: 1;
    background-color: #eee;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #999;
    font-size: 15px;
  }
  .dashboard{
    position: relative;
    z-index: 2;
    height: calc(100vh - 50px);
    overflow-y: auto;
    padding: 20px 20px 0;
    margin-left: -30px;
    margin-right: -30px;
    box-sizing: border-box;
    .activityCnt{
      overflow: hidden;
      &.loading{
        height: 140px;
        background-image: url(../assets/loading-2.svg);
        background-size: 36px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      .activities{
        display: flex;
        margin-top: 10px;
        .activityItem{
          width: 50%;
          position: relative;
          text-align: center;
          &.hourly{
            width: 4.16666666667%;
          }
          .activityBar{
            height: 160px;
            display: flex;
            border-bottom: #eee 1px solid;
            transition: all .3s ease;
            border-radius: 3px 3px 0 0;
            position: relative;
            z-index: 2;
            padding-top: 10px;
            @media (max-width: 1460px) {
              height: 120px;
            }
            // @media (max-width: 680px) {
            //   height: 96px;
            // }
            .info{
              position: absolute;
              background-color: #fff;
              padding: 2px 6px 5px;
              font-size: 12px;
              left: 50%; top: 10px;
              transform: translateX(-50%);
              z-index: 3;
              white-space: nowrap;
              box-shadow: 2px 2px 6px rgba(0, 0, 0, .1);
              border-radius: 3px;
              display: none;
              text-align: center;
              color: #444;
              h4{
                margin: 0 0 -3px;
                font-weight: 600;
                font-size: 20px;
                color: inherit;
              }
            }
            &:hover{
              background-color: #f5f5fe;
              z-index: 3;
              .info{
                display: block;
              }
            }
            .theBar{
              width: 80%;
              max-width: 4px;
              background-color: #0067ff;
              margin: auto auto 0;
              border-radius: 3px 3px 0 0;
            }
          }
          .activityLabel{
            font-weight: 600;
            color: #999;
            font-size: 11px;
            line-height: 1;
            padding: 8px 0 12px;
            &.activityLabelRotated{
              transform: rotate(-45deg);
            }
          }
          &:first-child{
            margin-left: 20px;
          }
          &:last-child{
            margin-right: 20px;
          }
          &.past{
            .activityBar{
              .theBar{
                background-color: #999;
              }
            }
          }
          &.noLabel{
            .activityBar{
              border: none;
            }
          }
        }
      }
    }
    .sources{
      margin-bottom: 20px;
      .sourceItem{
        padding: 16px 20px 10px;
        display: flex;
        position: relative;
        .percentageCnt{
          position: absolute;
          left: 20px; right: 20px; bottom: 0;
        }
        .percentage{
          position: absolute;
          height: 4px;
          background-color: #0e5dd2;
          bottom: 0; left: 0;
          border-radius: 50px;
        }
        .source{
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          margin-right: auto;
          span{
            color: #767676;
          }
        }
        .count{
          font-weight: 600;
          white-space: nowrap;
        }
      }
    }
    .eventTimeline{
      margin: 20px 0 0;
      padding: 60px 0 56px;
      position: relative;
      .tlh{
        content: "";
        position: absolute;
        left: 161px; top: 0;
        background-color: #0e5dd2;
        border-radius: 50%;
        width: 20px; height: 20px;
        @media (max-width: 680px) {
          left: 1px;
        }
        &:before{
          content: "";
          position: absolute;
          left: 2px; right: 2px; top: 2px; bottom: 2px;
          border-radius: 50%;
          border: #fff 1px solid;
        }
        &:after{
          background-color: #0e5dd2;
          width: 1px; height: 120px;
          position: absolute;
          content: "";
          left: 50%; top: 100%;
          margin-left: -1px;
        }
      }
      .tlf{
        border: #0e5dd2 1px solid;
        padding: 6px 0;
        padding-left: 16px;
        box-sizing: border-box;
        border-radius: 50px;
        position: absolute;
        bottom: 0;
        left: 86px;
        font-weight: 600;
        color: #0e5dd2;
        width: 170px;
        transition: all .3s ease;
        cursor: pointer;
        @media (max-width: 680px) {
          left: -10px;
        }
        &:hover{
          box-shadow: 2px 2px 4px rgba(0, 0, 0, .1);
        }
        &:before{
          content: "";
          position: absolute;
          right: 15px; top: 0; bottom: 0;
          width: 18px;
          background-image: url(../assets/next-arrow-blue.png);
          background-size: contain;
          background-position: center;
          background-repeat: no-repeat;
        }
        &:after{
          background-color: #0e5dd2;
          width: 1px; height: 120px;
          position: absolute;
          content: "";
          left: 50%; bottom: 100%;
          margin-left: -1px;
          @media (max-width: 680px) {
            margin: 0;
            left: 19px;
          }
        }
      }
      .tlItem{
        position: relative;
        padding-left: 220px;
        @media (max-width: 680px) {
          padding-left: 44px;
        }
        .tlTime{
          position: absolute;
          left: 0; top: 0; bottom: 0;
          width: 170px;
          border-right: #0e5dd2 1px solid;
          font-size: 15px;
          color: #767676;
          padding: 16px 0 0;
          @media (max-width: 680px) {
            width: 10px;
          }
          span{
            @media (max-width: 680px) {
              display: none;
            }
          }
          &:before{
            content: "";
            position: absolute;
            width: 36px; height: 36px;
            background-color: #5351a4;
            border-radius: 50%;
            right: -18px; top: 12px;
            z-index: 7;
            background-image: url(../assets/tap.png);
            background-size: 20px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:after{
            content: "";
            position: absolute;
            width: 32px; height: 32px;
            right: -16px; top: 14px;
            border-radius: 50%;
            border: #fff 1px solid;
            z-index: 8;
            box-sizing: border-box;
          }
          &.Olahraga{
            &:before{
              background-color: #00b8a9;
              background-image: url(../assets/olahraga.png);
            }
          }
          &.Makanan{
            &:before{
              background-color: #e0874b;
              background-image: url(../assets/makanan.png);
              background-size: 26px auto;
            }
          }
          &.scroll{
            &:before{
              background-color: #f14723;
              background-image: url(../assets/scroll-bar.png);
            }
          }
          &.page_visit{
            &:before{
              background-color: #01b0b7;
              background-image: url(../assets/home.png);
            }
          }
          &.open_mission{
            &:before{
              background-color: rgb(27, 127, 110);
            }
          }
          &.open_category{
            &:before{
              background-color: rgb(27, 127, 110);
            }
          }
          &.join_challenge_of_the_day,
          &.join_challenge{
            &:before{
              background-color: #ff9934;
            }
          }
        }
        .tlInfo{
          padding: 16px 0;
          font-weight: 600;
          table{
            border: none;
            margin-top: 4px;
            width: 100%;
            tr{
              td{
                font-weight: 400;
                color: #767676;
                vertical-align: top;
                padding: 2px 0;
                &.td1{
                  padding-right: 30px;
                  width: 120px;
                  @media (max-width: 680px) {
                    width: 80px;
                  }
                }
                &.td2{
                  width: 10px;
                  @media (max-width: 680px) {
                    width: 8px;
                  }
                }
              }
            }
          }
        }
      }
      &.tlLoading{
        .tlh{
          background-image: url(../assets/loading-2.svg);
          background-size: 16px auto;
          background-position: center;
          background-repeat: no-repeat;
          background-color: #eee;
          &:before{
            display: none;
          }
          &:after{
            background-color: #eee;
          }
        }
      }
    }
    .panelCnt{
      display: flex;
      margin-bottom: 10px;
      position: relative;
      z-index: 3;
      &.panelCntFirst{
        margin-top: 20px;
      }
      &.panelCnt3{
        justify-content: space-between;
        gap: 10px;
        @media (max-width: 680px) {
          display: block;
        }
        .panelFull.panelL1.panel3{
          @media (max-width: 680px) {
            width: auto;
          }
        }
      }
      &.panelChart{
        z-index: 4;
      }
      .panelFull{
        display: block;
        background-color: #fff;
        border-radius: 5px;
        width: 100%;
        padding: 20px 10px;
        padding-left: 0;
        box-sizing: border-box;
        // box-shadow: 2px 2px 4px rgba(0,0,0,.1);
        border: #eee 1px solid;
        position: relative;
        &.activity{
          padding-right: 0;
          padding-bottom: 6px !important;
          &.interactions{
            padding-bottom: 0 !important;
            .moreCnt{
              bottom: auto; top: 20px;
            }
          }
          .panelHeader{
            margin-bottom: 0 !important;
          }
        }
        .allAvg{
          font-size: 30px;
          margin: -10px 20px 0;
          border-bottom: #eee 1px solid;
          padding-bottom: 10px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .moreCnt{
          position: absolute;
          right: 20px;
          bottom: 20px;
          .moreBtn{
            color: #0057d8;
            font-weight: 600;
            position: relative;
            padding-right: 26px;
            cursor: pointer;
            @media (max-width: 640px) {
              display: none;
            }
            &:hover{
              color: #0067ff;
            }
            &:before{
              content: "";
              position: absolute;
              right: 0; top: 1px; bottom: 0; width: 16px;
              background-image: url(../assets/next-arrow-blue.png);
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
            }
            &.disabled{
              filter: grayscale(1);
              opacity: .4;
              cursor: default;
            }
          }
        }
        .chartOptions{
          position: absolute;
          right: 20px; top: 20px;
          z-index: 9;
          .xOpts{
            .coBtn{
              border: #ccc 1px solid;
              border-radius: 5px;
              padding: 5px 12px;
              padding-right: 30px;
              position: relative;
              cursor: pointer;
              transition: all .3s ease;
              font-size: 15px;
              &:hover{
                box-shadow: 2px 2px 2px rgba(0,0,0,.1);
              }
              &:before{
                content: "";
                position: absolute;
                right: 10px; top: 1px; bottom: 0;
                width: 10px;
                background-image: url(../assets/down-arrow.png);
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
              }
            }
            .coOpts{
              position: absolute;
              right: 0; top: 100%;
              background-color: #fff;
              box-shadow: 0 1px 6px rgba(0,0,0,.2);
              padding: 10px 0;
              border-radius: 5px;
              display: none;
              li{
                list-style: none;
                white-space: nowrap;
                font-size: 15px;
                padding: 8px 20px;
                transition: all .3s ease;
                cursor: pointer;
                &:hover{
                  background-color: #f5f5fe;
                }
              }
            }
            &:hover{
              .coOpts{
                display: block;
              }
            }
          }
        }
        .panelNumber{
          text-align: center;
          margin-top: -20px;
          h4{
            margin: 0 0 10px;
            font-size: 76px;
            font-weight: 700;
          }
          span{
            color: #767676;
            font-size: 15px;
          }
        }
        .panelHeader{
          margin: -8px 20px 0;
          height: 32px;
          font-size: 16px;
          // color: #767676;
          font-weight: 600;
          // color: #444;
          // text-transform: uppercase;
          display: flex;
          align-items: center;
          &.phTl{
            margin-left: 116px;
          }
          .panelRight{
            margin-left: auto;
            display: flex;
            align-items: center;
            .monthName{
              display: inline-block;
              min-width: 140px;
              text-align: center;
              text-transform: uppercase;
              color: #767676;
            }
            .panelCal{
              width: 32px; height: 32px;
              background-image: url(../assets/arrow-right-black.png);
              background-size: 14px auto;
              background-position: center;
              background-repeat: no-repeat;
              margin-left: 10px;
              border-radius: 50%;
              transition: all .3s ease;
              cursor: pointer;
              &.pcl{
                margin-right: 10px;
                margin-left: 0;
                background-image: url(../assets/arrow-left-black.png);
              }
              &:hover{
                background-color: #f5f5fe;
              }
            }
          }
        }
        &.panelL1{
          width: 300px;
          padding-right: 0;
          padding-bottom: 60px;
          &.panel3{
            width: 33.333333%;
            padding-bottom: 30px;
            .panelHeader{
              text-align: center;
              margin-bottom: 30px;
              justify-content: center;
            }
          }
          &.panel4{
            width: 25%;
          }
          &.panel5{
            width: 20%;
          }
          &.panelL12{
            margin-left: auto;
            width: 50%;
          }
          .panelHeader{
            margin-bottom: 30px;
          }
        }
        &.panelR2{
          width: calc(100% - 330px);
          margin-left: auto;
          padding-bottom: 36px;
          &.panelR22{
            width: calc(50% - 15px);
            margin-left: 0;
          }
        }
      }
      &.panelWrap{
        flex-wrap: wrap;
        justify-content: flex-start;
        gap: 0;
        margin: 0 -5px;
        .panelFull{
          width: calc(33.333333333% - 10px) !important;
          margin: 0 5px 10px !important;
          .allAvg{
            font-size: 15px;
            font-weight: 600;
          }
        }
      }
      &.noBorder{
        .panelFull{
          border: none;
        }
      }
    }
  }
}
</style>
